/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import InputGroup from 'react-bootstrap/InputGroup';
import DepartmentModal from "./DepartmentForm";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import {
  fetchMasterList,
  addMasterRecord,
  deleteMasterRecord,
  fetchMasterListById,
  searchMasterList,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { toastFunc } from "../../../../components/common/util";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { ErrorModal } from "../../../common/errorModal";
import ViewMachines from "./ViewMachines";
import { AlertModal } from "../../../common/AlertModal";
import { formatDateTime } from "../../../../common/Validations";

const Departments = () => {
  const [open, setOpen] = useState(false);
  const [openViewMachines, setOpenViewMachines] = useState(false);
  const [machinesData, setMachinesData] = useState([]);
  const [deptcode, setDeptCode] = useState([]);
  const [isAlert, setIsAlert] = useState(false);
  const [searchValue,setSearchValue] = useState();
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [selectedItem, setSelectedItem] = useState([]);
  const [editDept, setEditDept] = useState();
  const [confirmModel, setConfirmModel] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen(false);
  };
  const handleViewMachinesClose = () => {
    setOpenViewMachines(false);
  };
  useEffect(() => {
    dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT)); // userSlice store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = (data, edit) => {
    const param = { ...data };
    if (!edit) {
      param.method = Constants.MASTER.DEPARTMENT.ADD;
    } else {
      param.method = Constants.MASTER.DEPARTMENT.UPDATE;
    }
    param.edit = edit;
    dispatch(addMasterRecord(param)).then((res) => {
      console.log(">> item >>", res);
      if (res?.payload?.status === 200) {
        if (!edit) {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_department.success_message"),
            2000
          );
        } else {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_department.update_success_message"),
            2000
          );
        }
        dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT)); // userSlice store
        setOpen(false);
      } else if (res?.payload?.errorcode === 1001) {
        // toastFunc(Constants.MASTER.TOAST.error,t("msg_master_list.msg_department.duplicate_dept"),4000)
        setError(t("msg_master_list.msg_department.duplicate_dept"));
        setIsError(true);
      } else {
        setError(t("msg_master_list.msg_department.department_add_error"));
        setIsError(true);
        //toastFunc(Constants.MASTER.TOAST.error,t("msg_master_list.msg_department.invalid_input"),4000)
      }
    });
  };

  const handleDelete = () => {
    let param = {};
    param.deptList = selectedItem;
    param.method = Constants.MASTER.DEPARTMENT.DELETE;

    dispatch(deleteMasterRecord(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_department.delete_success_message"),
          2000
        );
        dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT));
        setSelectedItem([]);
        setConfirmModel(false);
      } else {
        setIsError(true);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_master_list.msg_department.invalid_input"),
          4000
        );
      }
    });
  };

  const handleOpen = (data) => {
    if (data) {
      setEditDept(data);
    }
    setOpen(true);
  };


  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store

  let rowsData = masterList[Constants.MASTER.DEPARTMENT.name]?.data;

  const handleSearch = () => {
    const param = { 
     ...Constants.MASTER.DEPARTMENT,
      value: searchValue };
    if(searchValue){
      dispatch(searchMasterList(param)).then((res) => {
        if (res?.payload?.status === 200) {
          rowsData = res?.payload?.data;
        }
      });
    }
  };

  const handleRowSelected = ({ selectedRows }) => {
    const selectDept = selectedRows.map((item) => item.deptCode);
    setSelectedItem([...selectDept]);
  };
  const handleViewMachines = (row) => {
    let param = {};
    param.url = "getMasterListDataById";
    param.page = Constants.MASTER.MACHINES.name;
    param.id = row.deptCode;

    if (row.deptCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        setOpenViewMachines(true);
        setMachinesData(result?.payload);
        setDeptCode(row.deptCode);
      });
    }
  };

  const confirmBeforeDelete = (data, singleDelete = false) => {
    if (singleDelete) {
      setSelectedItem([data.deptCode]);
      setConfirmModel(true);
    } else {
      if (selectedItem.length === 0) {
        setIsAlert(true);
        return
      } else {
        setConfirmModel(true);
      }
    }
  };
  const resetAlert = () => {
    setIsAlert(false);
  };
  const resetError = () => {
    setIsError(false);
    setError("");
  };

  const onSearchChange = (e) => {
    if(e.target.value){
      setSearchValue(e.target.value)  
    }else{
      dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT))
      setSearchValue(e.target.value)
    }
  };

  const columnsData = [
    {
      name: t("msg_common.actions"),
      cell: (row) => (
        <>
          <span>
            <i
              className="bi bi-pencil-square iconTable"
              onClick={() => handleOpen(row)}
            ></i>
          </span>
          <span>
            <i
              className="bi bi-trash3 iconTable"
              onClick={() => confirmBeforeDelete(row, true)}
            ></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: t("msg_master_list.msg_department.code"),
      selector: (row) => row.deptCode,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.deptCode} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_department.department_name"),
      selector: (row) => row.deptName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.deptName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_department.view_machines"),
      cell: (row) => (
        <Button
          variant="outline-primary"
          onClick={() => handleViewMachines(row)}
        >
          {row.lastName}
          {"Machines"}
        </Button>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_common.status"),
      cell: (row) => (
        <>
          {row.status === Constants.MASTER.STATUS.Active ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.active")}
            </span>
          ) : row.status === Constants.MASTER.STATUS.Inactive ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.inactive")}
            </span>
          ) : (
            row.status
          )}
        </>
      ),
      center: true,
      width: "200px",
    },
    {
      name: t("msg_common.created_date"),
      selector: (row) => row.createdDate,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{formatDateTime(row.createdDate)} </p>
        </div>
      ),
      center: true,
      width: "250px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t("msg_master_list.msg_department.name")}
            </h2>
            <p className="subText">
              {t("msg_master_list.msg_department.details")}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="rightSide" >
        <Form>
                    <Form.Group>
                        <InputGroup>
                            <Form.Control
                                type="search"
                                placeholder={t("msg_common.search_placeholder")}
                                onChange={(e) => onSearchChange(e)}
                            />
                            <InputGroup.Text>
                            <i className="bi bi-search" onClick={handleSearch}></i>
                            </InputGroup.Text>
                        </InputGroup>
                    </Form.Group>
                </Form>
        </Col>
        <hr />
      </Row>
      <MasterList
        columnsData={columnsData}
        rowsData={rowsData}
        paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
        pagination
        selectableRows
        handleClose
        handleOpen={handleOpen}
        handleDelete={confirmBeforeDelete}
        handleRowSelected={handleRowSelected}
      />
      {open && (
        <DepartmentModal
          data={editDept}
          show={open}
          onHide={handleClose}
          onSave={handleSave}
        ></DepartmentModal>
      )}
      {confirmModel && (
        <ConfirmationModal
          show={confirmModel}
          heading={t("msg_master_list.msg_department.delete_confirm_heading")}
          bodyMessage={t("msg_master_list.msg_department.delete_confirm_body")}
          onDelete={() => handleDelete()}
          onHide={() => setConfirmModel(false)}
          type={"delete"}
        ></ConfirmationModal>
      )}
      {isError && (
        <ErrorModal
          show={isError}
          heading={t("msg_master_list.msg_department.department_error_heading")}
          bodyMessage={error}
          onHide={() => {
            resetError();
          }}
        ></ErrorModal>
      )}

      <ViewMachines
        rowsData={machinesData}
        show={openViewMachines}
        onHide={handleViewMachinesClose}
        deptcode={deptcode}
      ></ViewMachines>

      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={t("msg_common.selectRecord")}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
    </main>
  );
};

export default Departments;
